import React, { useEffect } from "react";
import { connect } from "react-redux";
import { logOut, limparAlertas } from "../../actions";
import { Redirect } from "react-router-dom";

function Logout(props) {

  useEffect(() => { props.logOut(); props.limparAlertas(); }, []);

  return <Redirect to="/" />;
}


export default connect(null, { logOut, limparAlertas })(Logout);
